var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3218_158827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.667969 0.667969L15.3346 15.3346M11.148 7.37464C11.694 7.64114 12.2047 7.97483 12.668 8.36797M3.33464 8.36797C4.32269 7.54185 5.51188 6.99211 6.7813 6.77463M7.1413 3.36797C8.56958 3.25288 10.0064 3.42675 11.366 3.87918C12.7256 4.33162 13.9801 5.05335 15.0546 6.0013M0.947969 6.0013C1.87275 5.18387 2.9331 4.53412 4.0813 4.0813M5.68797 10.7413C6.36477 10.2605 7.17442 10.0021 8.00464 10.0021C8.83485 10.0021 9.6445 10.2605 10.3213 10.7413M8.0013 13.3346H8.00797",
    stroke: "#545454",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3218_158827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOff);
export default __webpack_public_path__ + "static/media/wifiOff.f574ece2dfeca45ef64d8b647a8dafcd.svg";
export { ForwardRef as ReactComponent };